// extracted by css-extract-rspack-plugin
export default {"slottedList":"IssueDashboardKnownViewPage-module__slottedList__ghtZ5","slottedListBody":"IssueDashboardKnownViewPage-module__slottedListBody__Txevh"};